exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-group > button {\n  color: #337ab7;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/shared/pagination-bootstrap/pagination-bootstrap.component.css
// module id = ../../../../../src/app/shared/pagination-bootstrap/pagination-bootstrap.component.css
// module chunks = main